import { CanActivateFn, Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { localStorageKeys } from 'src/app/core/enum';
import { UtilService } from '../services/util.service';

@Injectable()
export class navigationPermission {
  constructor(private storageService: StorageService, private utilService : UtilService){}
   async canActivate(navigationCode:any){
   var navigation_codes:any =  await this.storageService.get(localStorageKeys.navigation_code)
   return navigation_codes.some((code: any) => {
    return code == navigationCode
  })
  }

  logout(){
    this.utilService.logout();
    return false;
  }
}

export const navigationGuard: CanActivateFn = async (route, state) => {
  const permissionService = inject(navigationPermission);
  const hasPermission = await permissionService.canActivate(route.data['navigationCode']);

  if (hasPermission) {
    return true;
  } else {
    return permissionService.logout();
  }
};
